import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import TableSkeleton from "../skeletons/expert/tableSkeleton";
import InfoMessageBoxTD from "../react-tables/utils/infoMessageBox";
import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Icon } from "@iconify/react";

function ConsultationBox(props) {
  const dataConsultation = props.data || [];
  const isCallsSection = props.title === "APPELS EFFECTUÉS";
  const titles = isCallsSection ? [...props.titles, "Audio"] : props.titles;

  return (
    <div className="consultation-box">
      <h4 className="title">{props.title}</h4>
      <div className="tableContainer">
        {props.isLoading ? (
          <TableSkeleton columnCount={titles.length} rowCount={2} />
        ) : (
          <Table>
            <Thead>
              <Tr>
                {titles.map((elem, i) => {
                  return <Th key={i}>{elem}</Th>;
                })}
              </Tr>
            </Thead>
            <Tbody>
              <CellRow 
                dataConsultation={dataConsultation} 
                cols={titles.length}
                isCallsSection={isCallsSection}
              />
            </Tbody>
          </Table>
        )}
      </div>
    </div>
  );
}

function CellRow(props) {
  const calls = props.dataConsultation;
  const isCallsSection = props.isCallsSection;

  if(calls.length === 0) return <InfoMessageBoxTD colSpan={props.cols}/>
  
  return (
    <>
      {calls.map((call) => {
        // Pour les appels, on exclut recordUrl de l'affichage normal
        let displayValues;
        if (isCallsSection && call.recordUrl !== undefined) {
          // Exclure recordUrl des valeurs à afficher
          const { recordUrl, ...rest } = call;
          displayValues = Object.values(rest);
        } else {
          displayValues = Object.values(call);
        }
        
        return (
          <Tr key={call.id}>
            {displayValues.map((value, index) => (
              <Td key={index}>{value}</Td>
            ))}
            {isCallsSection && (
              <Td>
                {call.recordUrl ? (
                  <AudioPlayer recordUrl={call.recordUrl} />
                ) : (
                  <span style={{ color: '#999', fontStyle: 'italic' }}>-</span>
                )}
              </Td>
            )}
          </Tr>
        );
      })}
    </>
  );
}

function AudioPlayer({ recordUrl }) {
  const [audioUrl, setAudioUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const audioUrlRef = useRef(null);

  useEffect(() => {
    if (!recordUrl) return;

    const loadAudio = async () => {
      setIsLoading(true);
      setError(null);
      
      try {
        // Extraire le token de l'URL (gérer les cas ?token= et &token=)
        let token = null;
        let cleanUrl = recordUrl;
        
        // Utiliser une regex pour extraire le token (gère ?token= et &token=)
        const tokenMatch = recordUrl.match(/[?&]token=([^&?#]*)/);
        if (tokenMatch) {
          token = decodeURIComponent(tokenMatch[1]);
          // Retirer le token de l'URL de manière simple
          cleanUrl = recordUrl.replace(/[?&]token=[^&?#]*/, '');
          // Nettoyer les ? ou & orphelins
          cleanUrl = cleanUrl.replace(/\?&/, '&').replace(/[?&]$/, '').replace(/\?$/, '');
        }

        // Utiliser le token comme Bearer token
        const headers = {};
        if (token) {
          headers['Authorization'] = `Bearer ${token}`;
        }

        console.log('Loading audio:', { cleanUrl, hasToken: !!token });

        const response = await axios.get(cleanUrl, {
          headers: headers,
          responseType: 'blob',
        });

        const blob = new Blob([response.data], { type: 'audio/wav' });
        const blobUrl = URL.createObjectURL(blob);
        audioUrlRef.current = blobUrl;
        setAudioUrl(blobUrl);
      } catch (err) {
        console.error("Erreur lors du chargement de l'audio:", err);
        console.error("Détails:", err.response?.status, err.response?.statusText);
        setError(`Erreur de chargement: ${err.response?.status || err.message}`);
      } finally {
        setIsLoading(false);
      }
    };

    loadAudio();

    // Nettoyer l'URL blob lors du démontage
    return () => {
      if (audioUrlRef.current) {
        URL.revokeObjectURL(audioUrlRef.current);
        audioUrlRef.current = null;
      }
    };
  }, [recordUrl]);

  if (isLoading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <Icon icon="svg-spinners:3-dots-fade" style={{ fontSize: '16px' }} />
        <span style={{ fontSize: '12px', color: '#666' }}>Chargement...</span>
      </div>
    );
  }

  if (error) {
    return (
      <span style={{ color: '#d32f2f', fontSize: '12px' }}>
        <Icon icon="material-symbols:error-outline" style={{ fontSize: '14px', verticalAlign: 'middle' }} />
        {error}
      </span>
    );
  }

  if (!audioUrl) {
    return null;
  }

  return (
    <audio controls style={{ width: '200px', height: '32px' }}>
      <source src={audioUrl} type="audio/wav" />
      Votre navigateur ne supporte pas l'élément audio.
    </audio>
  );
}

export default ConsultationBox;
